import React, {useState } from 'react';
import styled from 'styled-components';
import {Link } from 'react-router-dom';
import {FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF, 
  faXTwitter, 
  faInstagram, 
  faLinkedinIn 
} from '@fortawesome/free-brands-svg-icons';
import {faEnvelope } from '@fortawesome/free-solid-svg-icons';

// Styled components are defined in the styles file
import {
  FooterContainer, 
  FooterContent, 
  FooterSection, 
  FooterTitle, 
  FooterLink, 
  SocialLinks, 
  SocialIcon, 
  Copyright,
  NewsletterForm,
  NewsletterInput,
  SubscribeButton
} from './footer.styles';

export const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would handle the form submission, e.g., send the email to your backend
    console.log(`Subscribing with email: ${email}`);
    alert(`Thank you for subscribing, ${email}!`);
    setEmail('');
  };

  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterTitle>GREMA</FooterTitle>
          <p>
            GLOBAL REAL ESTATE AND MARKETING AGENCY. <br />
Buy a stall at GREMA, showcase your business, and connect with customers all over the world        </p>
          <SocialLinks>
            <SocialIcon href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebookF} />
            </SocialIcon>
            <SocialIcon href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" aria-label="X Twitter">
              <FontAwesomeIcon icon={faXTwitter} />
            </SocialIcon>
            <SocialIcon href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </SocialIcon>
            <SocialIcon href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FontAwesomeIcon icon={faLinkedinIn} />
            </SocialIcon>
          </SocialLinks>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Quick Links</FooterTitle>
          <FooterLink to="/">Home</FooterLink>
          <FooterLink to="/buy-stall">Advertise Here</FooterLink>
          <FooterLink to="/promotions">Promotions</FooterLink>
          <FooterLink to="/services">Services</FooterLink>
          <FooterLink to="/contact">Contact Us</FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>About Us</FooterTitle>
          <FooterLink to="/why-grema">Why GREMA</FooterLink>
          <FooterLink to="/working-hours">Working Hours</FooterLink>
          <FooterLink to="/user-guide">User Guide</FooterLink>
          <FooterLink to="/policy">Our Policy</FooterLink>
            <FooterLink to="/policy">Partners</FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Newsletter</FooterTitle>
          <p>Stay up to date with the latest stalls and promotions.</p>
          <NewsletterForm onSubmit={handleSubscribe}>
            <NewsletterInput 
              type="email" 
              placeholder="Your email address" 
              value={email}
              onChange={(e: {target: {value: React.SetStateAction<string>; }; }) => setEmail(e.target.value)}
              required
            />
            <SubscribeButton type="submit">
              <FontAwesomeIcon icon={faEnvelope} /> Subscribe
            </SubscribeButton>
          </NewsletterForm>
        </FooterSection>
      </FooterContent>

      <Copyright>
        &copy; {new Date().getFullYear()} GREMA. All Rights Reserved.
      </Copyright>
    </FooterContainer>
  );
};